import type { ReactNode } from "react"

interface InlineWrapperProps {
    children: ReactNode
}

export function InlineWrapper({ children }: InlineWrapperProps) {
    return <div className="py-1.5">{children}</div>
}
